import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface FavouriteFilterState {
  searchTerm: string;
}

const initialState: string = '';

export const favouriteFilterSlice = createSlice({
  name: 'favouriteFilter',
  initialState,
  reducers: {
    setSearchTerm: (state, action: PayloadAction<string>) => {
      return action.payload;
    },
    resetSearchTerm: () => {
      return '';
    }
  }
});

export const { setSearchTerm, resetSearchTerm } = favouriteFilterSlice.actions;
export default favouriteFilterSlice.reducer;
